// @flow

import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';

import { log } from '../../utils/jsUtils';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ZapierImg from '../../assets/zapier.png';

import { createClasses } from '../../utils/stylesUtils';
import MemberStructuralStyles from '../Styles/CommonMemberStructuralStyles.Style';
import styles from './Styles/IntegrationsContent.Style';
import combineStyles from '../../utils/stylesUtils';

type Props = {};

function EmbedZapierScript() {
  useEffect(() => {
    const widget = document.createElement('script');
    widget.type = 'text/javascript';
    widget.async = true;
    // widget.src = 'https://zapier.com/apps/embed/widget.js?services=mailchimp&html_id=zapier-widget';
    widget.src = 'https://zapier.com/apps/embed/widget.js?services=askneo&html_id=zapier-widget';
    document.body.appendChild(widget);
  }, []);

  return <Box component="div" id="zapier-widget" />;
}

// eslint-disable-next-line react/no-multi-comp
const IntegrationsContent = (props: Props) => {
  const theme = useTheme();
  const combinedStyles = combineStyles(styles, MemberStructuralStyles);
  const classes = createClasses(combinedStyles, theme);

  return (
    <Box sx={classes.integrationsContent}>
      <Box sx={classes.contentCtr}>
        <Box 
          component="a"
          sx={classes.ctaBtnAnchor}
          href='https://zapier.com/apps/askneo/integrations'
          target='_blank'
        >
          <Button
            sx={classes.ctaBtn}
            color='secondary'
            endIcon={<OpenInNewIcon />}
            startIcon={<img height={24}
                            src={ZapierImg}
                       />}
            variant='contained'
          >
            Connect Askneo to 4000+ apps with Zapier
          </Button>
        </Box>
        <Typography variant='h3'><br />Ready-to-use automations</Typography>
        <EmbedZapierScript />

      </Box>
    </Box>
  );
};

export default IntegrationsContent;